import { render, staticRenderFns } from "./FloatingPanel.vue?vue&type=template&id=e0af2b86&scoped=true"
import script from "./FloatingPanel.vue?vue&type=script&lang=js"
export * from "./FloatingPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatingPanel.vue?vue&type=style&index=0&id=e0af2b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0af2b86",
  null
  
)

export default component.exports